import styled from "styled-components";
import { devicesNovo } from "../../utils/styled/_variables.styled";

export const DoubleContainerBox = styled.div`
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  max-width: 898px;

  @media ${devicesNovo.smallDesktop} {
    max-width: 1366px;
    display: flex;
    flex-direction: row;
    gap: 29px;
    justify-content: center;
  }

  .cmp-container {
    margin: 0 24px;
    @media ${devicesNovo.smallDesktop} {
        margin: 48px 40px;
        max-width: 546px;
    }

    > div {
        h1 {
          font-size: 24px;
          line-height: 36px;
          margin-bottom: 8px;
          @media ${devicesNovo.smallDesktop} {
            font-size: 32px;
            line-height: 48px;
            margin-bottom: 15px;
          }
        }
        p {
          font-weight: 400;
          font-size: 16px;
          line-height: 28px;
        }
    }
  }
`;
